import { PaymentBankAccountQueryService } from "../../../services/payments/PaymentBankAccountQueryService";
import { PaymentBankAccountModel } from "../../models/PaymentBankAccount";
import { IQueryPaymentBankAccountRepository } from "../../ports/payments/IQueryPaymentBankAccountRepository";
import Query from "../Query";

class PaymentBankAccountQuery
  extends Query<PaymentBankAccountModel>
  implements IQueryPaymentBankAccountRepository
{
  constructor(public queryService: PaymentBankAccountQueryService) {
    super(queryService);
  }
}

export default PaymentBankAccountQuery;
